import { pipe } from 'fp-ts/function';
import {
    DateTimeService,
    DateTimeUtc,
    DateTimeUtcService,
    DateTimeUtils,
    Time,
    WallClockDate,
    WallClockDateService,
} from '@mews/framework/datetime';

export const toDateTimeUtc = (date: string, hotelTimezone: string): DateTimeUtc =>
    DateTimeService.toUtc(
        DateTimeService.fromDate(WallClockDateService.toTimezonedDate(WallClockDateService.parse(date), hotelTimezone))
    );

export const toUtc = (date: string, hotelTimezone: string): string => toDateTimeUtc(date, hotelTimezone).value;

export const toUtcWithoutMiliseconds = (date: string, hotelTimezone: string): string =>
    DateTimeUtcService.toISOString(toDateTimeUtc(date, hotelTimezone), {
        suppressMilliseconds: true,
    });

interface GetIsoDateOptions {
    timezone: string;
}

export const getDateIsoStringFromDateTimeUtcString = (dateTimeUtcString: string, { timezone }: GetIsoDateOptions) =>
    DateTimeUtils.dateTimeUtcStringToDateISOString(dateTimeUtcString, timezone);

export const getRestrictedMaxDate = (availabilityBlockEndDate: WallClockDate | null, isDayUse: boolean) => {
    if (!availabilityBlockEndDate) {
        return null;
    }
    return isDayUse ? availabilityBlockEndDate : WallClockDateService.addDays(availabilityBlockEndDate, 1);
};

interface GetDatesAndTimesOptions {
    startUtc: string;
    endUtc: string;
    timezone: string;
}

export const getDatesAndTimes = ({ startUtc, endUtc, timezone }: GetDatesAndTimesOptions) => ({
    startTime: DateTimeUtils.dateTimeUtcStringToTime(startUtc, timezone),
    endTime: DateTimeUtils.dateTimeUtcStringToTime(endUtc, timezone),
    startDate: DateTimeUtils.dateTimeUtcStringToWallClockDate(startUtc, timezone),
    endDate: DateTimeUtils.dateTimeUtcStringToWallClockDate(endUtc, timezone),
});

export const getFormattedUtcDate = ({ time, date, timezone }: { time?: Time; date?: string; timezone?: string }) => {
    if (time == null || date == null || timezone == null) {
        return undefined;
    }
    return pipe(
        DateTimeUtils.createDateTimeUtc({
            time,
            date: WallClockDateService.parse(date),
            timezone,
        }),
        (utc) => DateTimeUtcService.toISOString(utc, { suppressMilliseconds: true })
    );
};
